"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorage = void 0;
class SessionStorage {
    constructor() {
        this.data = new Map();
    }
    async setSession(walletAddress, session) {
        this.data.set(walletAddress, session);
    }
    async getSession(walletAddress) {
        return this.data.get(walletAddress) || null;
    }
}
exports.SessionStorage = SessionStorage;
